import { render } from "./News.vue?vue&type=template&id=a46bd246&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=a46bd246&scoped=true&lang=less"
import "./News.vue?vue&type=style&index=1&id=a46bd246&scoped=true&lang=less"
import "./News.vue?vue&type=style&index=2&id=a46bd246&scoped=true&lang=less"

import exportComponent from "D:\\workCode\\cbc\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a46bd246"]])

export default __exports__